import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

var dark = false;
if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
  dark = false;
}

export default new Vuetify({
    theme: {
        options: {
            cspNonce: process.env.VUE_APP_NONCE
        },
        dark: dark,
        themes: {
            light: {
                primary: '#9c0047',
                secondary: '#2b6ea9',
                accent: '#275c9b',
                error: '#b71c1c'
            },
            dark: {
                primary: '#d90063',
                secondary: '#2b6ea9',
                accent: '#275c9b',
                error: '#b71c1c'
            }
        }
    } 
});
